import {gql} from '@apollo/client';

export const UPDATE_APPLE_MUSIC_TOKEN_MUTATION = gql`
  mutation UpdateAppleMusicTokenMutation($token: String!) {
    updateAppleMusicToken(token: $token) {
      user {
        username
        id
        fullName
        phoneNumber
        appleMusicToken
      }
      errors
    }
  }
`;
